import FormText from 'components/form/FormText';
import IndicatorButton from 'components/indicator/IndicatorButton';
import { AppConst } from 'constants/appConst';

import { useAppState } from 'hooks/useAppState';
import { useEffect, useState, type JSX } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { submit } from 'utils/app';

/**
 * アカウント登録画面
 * 2025/05/09 トライアルプラン改修で新しい画面を追加したため利用されていない
 */
export default function SignupOldIndex(): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 型定義 */
  /* ----------------------------------------------------------------------- */
  type FormStateType = {
    mailAddress: string;
  };

  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const { showBoundary } = useErrorBoundary();
  const navigate = useNavigate();

  const { isSignedIn, signUpRequest } = useAppState();

  const [initialized, setInitialized] = useState(false);
  const [processing, setProcessing] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormStateType>();

  /* ----------------------------------------------------------------------- */
  /* ライフサイクル関数定義 */
  /* ----------------------------------------------------------------------- */
  useEffect(() => {
    // 認証済の場合は、会社登録画面に遷移
    (async () => {
      try {
        if (await isSignedIn()) {
          navigate('/signupOld/company');
        }
      } catch (e: unknown) {
        showBoundary(e);
      } finally {
        setInitialized(true);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- 初回マウント時のみ実行する設計
  }, []);

  /* ----------------------------------------------------------------------- */
  /* プライベート関数定義 */
  /* ----------------------------------------------------------------------- */
  /**
   * 登録ボタン押下時の処理
   */
  const onSubmit = () =>
    submit(
      processing,
      setProcessing,
      handleSubmit(async (data: FormStateType) => {
        try {
          // サインアップリクエストを送信
          await signUpRequest(data.mailAddress);

          // ログイン認証コード入力画面に遷移
          navigate('/signin/auth', {
            state: {
              mailAddress: data.mailAddress,
              nextTo: '/signupOld/company',
            },
          });
        } catch (e: unknown) {
          showBoundary(e);
        }
      })
    );

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      {initialized && (
        <>
          <section className="section-login">
            <div className="container">
              <div className="card card-login">
                <div className="card-body">
                  <h1 className="card-title">アカウント登録</h1>
                  <p className="lead">
                    新規作成するカンパニーにログインするためのメールアドレスを入力してください。
                    既に他のカンパニーに参加しているメールアドレスも使用できます。
                  </p>

                  <form className="form-login">
                    <div>
                      <FormText
                        subject="メールアドレス"
                        name="mailAddress"
                        register={register}
                        errors={errors}
                        required={true}
                        maxLength={300}
                        format="email"
                      />
                    </div>
                    <div className="form-footer">
                      <button
                        type="button"
                        className="btn btn-submit w-100"
                        onClick={onSubmit}
                        disabled={processing}
                      >
                        <IndicatorButton visible={processing} />
                        次へ
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <div className="text-center">
                <a href={AppConst.url.privacy} target="_blank" className="caption">
                  privacy &amp; Terms
                </a>
              </div>
            </div>
          </section>
        </>
      )}
    </>
  );
}
